import { Directive, AfterViewInit } from "@angular/core";
import {
	Input,
	Output,
	EventEmitter,
	ElementRef,
	HostListener,
	ChangeDetectorRef,
} from "@angular/core";

@Directive({
	selector: "[appTransciptText]",
})
export class TranscriptTextDirective implements AfterViewInit {
	@Input() transcripttext: string;
	@Input() width?: string;
	@Input() height?: string;
	@Input() borderradius?: string;
	@Input() borderwidth?: string;
	@Input() bordercolor?: string;
	@Input() borderstyle?: string;
	@Input() hpadding?: string;
	@Input() vpadding?: string;
	@Input() bgcolor?: string;
	@Input() fontsize?: string;
	@Input() fontcolor?: string;
	private el: HTMLElement;
	constructor(
		private elementRef: ElementRef,
		private changeDetector: ChangeDetectorRef
	) {
		console.log("TransciptTextDirective");
		this.el = elementRef.nativeElement;
	}
	ngAfterViewInit() {
		if (!this.el) return;
		this.el.style.backgroundColor = this.bgcolor ? this.bgcolor : "";
		this.el.style.width = this.width ? this.width : "100%";
		this.el.style.height = this.height ? this.height : "100%";
		this.el.style.borderWidth = this.borderwidth ? this.borderwidth : "0px";
		this.el.style.borderRadius = this.borderradius ? this.borderradius : "0px";
		this.el.style.borderColor = this.bordercolor ? this.bordercolor : "";
		this.el.style.borderStyle = this.borderstyle ? this.borderstyle : "solid";
		this.el.style.paddingTop = this.vpadding ? this.vpadding : "20px";
		this.el.style.paddingBottom = this.vpadding ? this.vpadding : "10px";
		this.el.style.paddingLeft = this.hpadding ? this.hpadding : "10px";
		this.el.style.paddingRight = this.hpadding ? this.hpadding : "10px";
		this.el.style.fontSize = this.fontsize ? this.fontsize : "10px";
		this.el.style.color = this.fontcolor ? this.fontcolor : "#000000";

		this.el.innerHTML = this.transcripttext;
	}
	@HostListener("change") ngOnChanges() {
		this.el.innerHTML = this.transcripttext;
		this.changeDetector.markForCheck();
	}
}
